import { useQuery } from "@tanstack/react-query";
import type { User } from "firebase/auth";
import { userClubsRepository } from "../api/user-clubs-repository";

export const userClubsKeys = {
  byUser: (uid: string) => ["user-clubs", uid] as const,
};

export function useUserClubs(user: User | null) {
  return useQuery({
    queryKey: user ? userClubsKeys.byUser(user.uid) : ["user-clubs", "none"],
    queryFn: () => userClubsRepository.listForUser(user!),
    enabled: !!user,
    // Avoid re-running the admin probe on every route change. 10 minutes is
    // long enough for a single session, short enough that an invite linked
    // mid-session (via `complete_staff_invite`) gets picked up on next refetch.
    staleTime: 10 * 60_000,
  });
}
